export default {"src":"/_next/static/image/src/components/ComparisonChart/x-icon.58b043089fb874514ccb6b46fa1111d8.svg","height":35,"width":35};